import { render, staticRenderFns } from "./CommitteeEnvelopeLabel.vue?vue&type=template&id=1ad058b5&scoped=true"
import script from "./CommitteeEnvelopeLabel.vue?vue&type=script&lang=js"
export * from "./CommitteeEnvelopeLabel.vue?vue&type=script&lang=js"
import style0 from "./CommitteeEnvelopeLabel.vue?vue&type=style&index=0&id=1ad058b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad058b5",
  null
  
)

export default component.exports